import React from "react";
import IconCaretDown from "../icons/icon-caret-down";
import IconCaretsDown from "../icons/icon-carets-down";

interface RotatingIconProps {
  menu: string;
  currentMenu: string;
  iconType: "single" | "multiple";
}

const RotatingIcon: React.FC<RotatingIconProps> = ({ menu, currentMenu, iconType }) => {
  const IconComponent = iconType === "single" ? IconCaretDown : IconCaretsDown;

  return (
    <div className={currentMenu !== menu ? "rtl:rotate-90 -rotate-90" : ""}>
      <IconComponent
        className={
          currentMenu === menu
            ? "fill-orange-500 dark:group-hover:fill-white-dark"
            : "fill-gray-500 group-hover:fill-orange-500 "
        }
      />
    </div>
  );
};

export default RotatingIcon;
